import React from 'react';
import { Container } from 'react-bootstrap';
import classNames from 'classnames';
import PropTypes from 'prop-types';

import Background from './Background';

function Section({
  fluid,
  bg,
  image,
  overlay,
  position,
  video,
  bgClassName,
  className,
  children,
  containerClassname,
  ...rest
}) {
  const bgProps = {
    image, overlay, position, video,
  };
  if (bgClassName) {
    bgProps.className = bgClassName;
  }

  return (
    <section
      className={classNames({ [`bg-${bg}`]: bg }, className)}
      {...rest}
      style={{ paddingTop: '1em' }}
    >
      {image && <Background {...bgProps} />}
      <Container fluid={fluid} className={containerClassname}>{children}</Container>
    </section>
  );
}

Section.propTypes = {
  fluid: PropTypes.bool,
  bg: PropTypes.string,
  image: PropTypes.string,
  overlay: PropTypes.oneOfType([PropTypes.bool, PropTypes.string]),
  position: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.shape({
      x: PropTypes.string,
      y: PropTypes.string,
    }),
  ]),
  video: PropTypes.array,
  bgClassName: PropTypes.string,
  className: PropTypes.string,
  containerClassname: PropTypes.string,
  children: PropTypes.node,
};

Section.defaultProps = {
  fluid: false,
};

export default Section;
